module.exports = {"320772001":"花果山街道","320772002":"南城街道","320772003":"郁州街道","320772400":"云台农场","320772401":"南云台林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320772.json
// module id = 892
// module chunks = 0